import { userMe } from '@/logic/user'

// TODO Передлать на новый вариант
export function userMeStore() {
  return userMe.value
}
